'use client';

import React, { useState, useEffect, useRef, useCallback } from 'react';

// ─── SVG Icons ────────────────────────────────────────────────────────────────
const DropletIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z" />
    <path d="M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97" />
  </svg>
);

const SparklesIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L15.5 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" /><path d="M22 5h-4" /><path d="M4 17v2" /><path d="M5 18H3" />
  </svg>
);

const ArrowRightIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
  </svg>
);

const MenuIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="18" y2="18" />
  </svg>
);

const XIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M18 6 6 18" /><path d="m6 6 12 12" />
  </svg>
);

const CircleXIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" />
  </svg>
);

const CircleCheckIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" />
  </svg>
);

const Building2Icon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
    <path d="M10 6h4" /><path d="M10 10h4" /><path d="M10 14h4" /><path d="M10 18h4" />
  </svg>
);

const UsersIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const TargetIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
  </svg>
);

const MapPinIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ClockIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);

const ZapIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
  </svg>
);

const ChartColumnIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
    <path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" />
  </svg>
);

const TrendingUpIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
    <polyline points="16 7 22 7 22 13" />
  </svg>
);

const SendIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" />
    <path d="m21.854 2.147-10.94 10.939" />
  </svg>
);

const CheckCircleIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <path d="m9 11 3 3L22 4" />
  </svg>
);

const MailIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const PhoneIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const TwitterIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
  </svg>
);

const LinkedInIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const InstagramIcon = ({ className = '' }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
  </svg>
);

// ─── Counter Hook ─────────────────────────────────────────────────────────────
function useCountUp(target: number, duration: number = 2000, start: boolean = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime: number | null = null;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(ease * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

// ─── Scroll Reveal Hook ───────────────────────────────────────────────────────
function useScrollReveal(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return { ref, visible };
}

// ─── Magnetic Button ──────────────────────────────────────────────────────────
interface MagneticButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
  strength?: number;
}
function MagneticButton({ children, className = '', href, onClick, strength = 0.4 }: MagneticButtonProps) {
  const ref = useRef<HTMLDivElement>(null);
  const handleMouseMove = useCallback((e: React.MouseEvent) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left - rect.width / 2) * strength;
    const y = (e.clientY - rect.top - rect.height / 2) * strength;
    el.style.transform = `translate(${x}px, ${y}px)`;
  }, [strength]);
  const handleMouseLeave = useCallback(() => {
    if (ref.current) ref.current.style.transform = 'translate(0,0)';
  }, []);
  const inner = (
    <div
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      style={{ transition: 'transform 0.3s cubic-bezier(0.23, 1, 0.32, 1)' }}
      className={className}
    >
      {children}
    </div>
  );
  if (href) return <a href={href}>{inner}</a>;
  return inner;
}

// ─── Animated Counter Card ────────────────────────────────────────────────────
interface StatCardProps { value: string; label: string; numericValue: number; suffix: string; inView: boolean; delay?: number; }
function StatCard({ value, label, numericValue, suffix, inView, delay = 0 }: StatCardProps) {
  const count = useCountUp(numericValue, 2200, inView);
  return (
    <div
      className="relative overflow-hidden rounded-2xl p-6 text-center group"
      style={{
        background: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(0,212,255,0.2)',
        backdropFilter: 'blur(12px)',
        transition: `opacity 0.7s ease ${delay}ms, transform 0.7s cubic-bezier(0.23,1,0.32,1) ${delay}ms`,
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
      }}
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: 'radial-gradient(circle at center, rgba(0,212,255,0.08) 0%, transparent 70%)' }} />
      <div className="relative text-4xl sm:text-5xl font-black" style={{ fontFamily: 'DM Sans, sans-serif', background: 'linear-gradient(135deg, #00d4ff, #7c3aed)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
        {inView ? `${count}${suffix}` : '0'}
      </div>
      <div className="mt-2 text-sm font-semibold" style={{ color: 'rgba(180,200,255,0.8)' }}>{label}</div>
    </div>
  );
}

// ─── Reveal Wrapper ───────────────────────────────────────────────────────────
interface RevealProps { children: React.ReactNode; delay?: number; direction?: 'up' | 'left' | 'right'; className?: string; }
function Reveal({ children, delay = 0, direction = 'up', className = '' }: RevealProps) {
  const { ref, visible } = useScrollReveal();
  const transforms: Record<string, string> = { up: 'translateY(50px)', left: 'translateX(-50px)', right: 'translateX(50px)' };
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translate(0,0)' : transforms[direction],
        transition: `opacity 0.8s cubic-bezier(0.23,1,0.32,1) ${delay}ms, transform 0.8s cubic-bezier(0.23,1,0.32,1) ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

// ─── Floating Particle ────────────────────────────────────────────────────────
interface ParticleProps { x: number; y: number; size: number; color: string; duration: number; delay: number; }
function Particle({ x, y, size, color, duration, delay }: ParticleProps) {
  return (
    <div
      className="absolute rounded-full pointer-events-none"
      style={{
        left: `${x}%`, top: `${y}%`,
        width: size, height: size,
        background: color,
        animation: `particleFloat ${duration}s ease-in-out ${delay}s infinite`,
        opacity: 0.6,
        filter: 'blur(1px)',
      }}
    />
  );
}

// ─── Custom Cursor ────────────────────────────────────────────────────────────
function CustomCursor() {
  const cursorRef = useRef<HTMLDivElement>(null);
  const trailRef = useRef<HTMLDivElement>(null);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    let mouseX = 0, mouseY = 0;
    let trailX = 0, trailY = 0;
    let raf: number;

    const onMove = (e: MouseEvent) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (cursorRef.current) {
        cursorRef.current.style.left = `${mouseX}px`;
        cursorRef.current.style.top = `${mouseY}px`;
      }
    };

    const animate = () => {
      trailX += (mouseX - trailX) * 0.12;
      trailY += (mouseY - trailY) * 0.12;
      if (trailRef.current) {
        trailRef.current.style.left = `${trailX}px`;
        trailRef.current.style.top = `${trailY}px`;
      }
      raf = requestAnimationFrame(animate);
    };

    const onEnter = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('a, button, [data-magnetic]')) setHovered(true);
    };
    const onLeave = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.closest('a, button, [data-magnetic]')) setHovered(false);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onEnter);
    document.addEventListener('mouseout', onLeave);
    raf = requestAnimationFrame(animate);

    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onEnter);
      document.removeEventListener('mouseout', onLeave);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div
        ref={cursorRef}
        className="fixed pointer-events-none z-[9999] rounded-full"
        style={{
          width: hovered ? 48 : 12,
          height: hovered ? 48 : 12,
          marginLeft: hovered ? -24 : -6,
          marginTop: hovered ? -24 : -6,
          background: hovered ? 'rgba(0,212,255,0.15)' : '#00d4ff',
          border: hovered ? '2px solid #00d4ff' : 'none',
          transition: 'width 0.3s cubic-bezier(0.23,1,0.32,1), height 0.3s cubic-bezier(0.23,1,0.32,1), background 0.3s ease, margin 0.3s cubic-bezier(0.23,1,0.32,1)',
          mixBlendMode: 'screen',
        }}
      />
      <div
        ref={trailRef}
        className="fixed pointer-events-none z-[9998] rounded-full"
        style={{
          width: 40,
          height: 40,
          marginLeft: -20,
          marginTop: -20,
          border: '1px solid rgba(0,212,255,0.3)',
          background: 'transparent',
          mixBlendMode: 'screen',
        }}
      />
    </>
  );
}

// ─── Animated Headline ────────────────────────────────────────────────────────
function AnimatedHeadline({ text, className = '', delay = 0 }: { text: string; className?: string; delay?: number }) {
  const { ref, visible } = useScrollReveal(0.1);
  const words = text.split(' ');
  return (
    <div ref={ref} className={className} aria-label={text}>
      {words.map((word, i) => (
        <span
          key={i}
          className="inline-block mr-[0.25em]"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(60px)',
            transition: `opacity 0.7s cubic-bezier(0.23,1,0.32,1) ${delay + i * 80}ms, transform 0.7s cubic-bezier(0.23,1,0.32,1) ${delay + i * 80}ms`,
          }}
        >
          {word}
        </span>
      ))}
    </div>
  );
}

// ─── Noise Overlay ────────────────────────────────────────────────────────────
function NoiseOverlay() {
  return (
    <div
      className="fixed inset-0 pointer-events-none z-[9997] opacity-[0.03]"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
        backgroundSize: '256px 256px',
      }}
    />
  );
}

// ─── Contact Form ─────────────────────────────────────────────────────────────
interface FormField { value: string; touched: boolean; error: string; }
interface FormState {
  name: FormField;
  email: FormField;
  company: FormField;
  budget: FormField;
  message: FormField;
}

function ContactForm() {
  const { ref, visible } = useScrollReveal(0.1);
  const [form, setForm] = useState<FormState>({
    name: { value: '', touched: false, error: '' },
    email: { value: '', touched: false, error: '' },
    company: { value: '', touched: false, error: '' },
    budget: { value: '', touched: false, error: '' },
    message: { value: '', touched: false, error: '' },
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [focusedField, setFocusedField] = useState<string | null>(null);

  const validate = (name: keyof FormState, value: string): string => {
    switch (name) {
      case 'name': return value.trim().length < 2 ? 'Name must be at least 2 characters' : '';
      case 'email': return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Enter a valid email address' : '';
      case 'company': return '';
      case 'budget': return '';
      case 'message': return value.trim().length < 10 ? 'Message must be at least 10 characters' : '';
      default: return '';
    }
  };

  const handleChange = (name: keyof FormState, value: string) => {
    setForm(prev => ({
      ...prev,
      [name]: {
        value,
        touched: prev[name].touched,
        error: prev[name].touched ? validate(name, value) : '',
      },
    }));
  };

  const handleBlur = (name: keyof FormState) => {
    setFocusedField(null);
    setForm(prev => ({
      ...prev,
      [name]: {
        ...prev[name],
        touched: true,
        error: validate(name, prev[name].value),
      },
    }));
  };

  const isFormValid = () => {
    return (
      form.name.value.trim().length >= 2 &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.value) &&
      form.message.value.trim().length >= 10
    );
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const fields = Object.keys(form) as (keyof FormState)[];
    const newForm = { ...form };
    fields.forEach(f => {
      newForm[f] = { ...newForm[f], touched: true, error: validate(f, newForm[f].value) };
    });
    setForm(newForm);
    if (!isFormValid()) return;
    setSubmitting(true);
    await new Promise(r => setTimeout(r, 1800));
    setSubmitting(false);
    setSubmitted(true);
  };

  const getFieldStyle = (name: keyof FormState) => {
    const isFocused = focusedField === name;
    const hasError = form[name].touched && form[name].error;
    const isValid = form[name].touched && !form[name].error && form[name].value;
    let borderColor = 'rgba(0,212,255,0.15)';
    let boxShadow = 'none';
    if (isFocused) { borderColor = 'rgba(0,212,255,0.6)'; boxShadow = '0 0 0 3px rgba(0,212,255,0.1), 0 0 20px rgba(0,212,255,0.15)'; }
    if (hasError) { borderColor = 'rgba(239,68,68,0.6)'; boxShadow = '0 0 0 3px rgba(239,68,68,0.1)'; }
    if (isValid && !isFocused) { borderColor = 'rgba(34,197,94,0.5)'; boxShadow = '0 0 0 2px rgba(34,197,94,0.08)'; }
    return { borderColor, boxShadow };
  };

  const inputBase: React.CSSProperties = {
    width: '100%',
    background: 'rgba(255,255,255,0.04)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    color: '#e2e8f0',
    fontFamily: 'DM Sans, sans-serif',
    fontSize: '0.95rem',
    outline: 'none',
    transition: 'border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease',
    borderRadius: '0.875rem',
    padding: '0.875rem 1.125rem',
    border: '1px solid',
  };

  const budgetOptions = ['Under ₹50K', '₹50K – ₹1L', '₹1L – ₹5L', '₹5L – ₹20L', '₹20L+'];

  if (submitted) {
    return (
      <div
        ref={ref}
        className="flex flex-col items-center justify-center py-24 text-center"
        style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(40px)', transition: 'opacity 0.8s cubic-bezier(0.23,1,0.32,1), transform 0.8s cubic-bezier(0.23,1,0.32,1)' }}
      >
        <div
          className="mb-8 inline-flex p-6 rounded-full"
          style={{ background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)', boxShadow: '0 0 40px rgba(34,197,94,0.2)', animation: 'orbFloat 4s ease-in-out infinite' }}
        >
          <CheckCircleIcon className="h-16 w-16" style={{ color: '#22c55e' }} />
        </div>
        <h3 className="text-3xl font-black text-white mb-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>Message Sent!</h3>
        <p className="text-lg max-w-md" style={{ color: 'rgba(180,200,255,0.7)' }}>
          Our OOH strategy team will reach out within 24 hours to discuss your Bengaluru campaign.
        </p>
        <div className="mt-8 flex gap-2 items-center text-sm font-semibold" style={{ color: '#00d4ff' }}>
          <MailIcon className="h-4 w-4" />
          <span>info@aqvertise360.com</span>
        </div>
      </div>
    );
  }

  return (
    <form ref={ref} onSubmit={handleSubmit} noValidate
      style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(40px)', transition: 'opacity 0.8s cubic-bezier(0.23,1,0.32,1), transform 0.8s cubic-bezier(0.23,1,0.32,1)' }}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-5">
        {/* Name */}
        <div>
          <label className="block text-xs font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(0,212,255,0.7)' }}>
            Name <span style={{ color: '#f87171' }}>*</span>
          </label>
          <div className="relative">
            <input
              type="text"
              placeholder="Your full name"
              value={form.name.value}
              onChange={e => handleChange('name', e.target.value)}
              onBlur={() => handleBlur('name')}
              onFocus={() => setFocusedField('name')}
              style={{ ...inputBase, ...getFieldStyle('name') }}
            />
            {form.name.touched && !form.name.error && form.name.value && (
              <CircleCheckIcon className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4" style={{ color: '#22c55e' }} />
            )}
          </div>
          {form.name.touched && form.name.error && (
            <p className="mt-1.5 text-xs font-medium" style={{ color: '#f87171' }}>{form.name.error}</p>
          )}
        </div>

        {/* Email */}
        <div>
          <label className="block text-xs font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(0,212,255,0.7)' }}>
            Email <span style={{ color: '#f87171' }}>*</span>
          </label>
          <div className="relative">
            <input
              type="email"
              placeholder="you@company.com"
              value={form.email.value}
              onChange={e => handleChange('email', e.target.value)}
              onBlur={() => handleBlur('email')}
              onFocus={() => setFocusedField('email')}
              style={{ ...inputBase, ...getFieldStyle('email') }}
            />
            {form.email.touched && !form.email.error && form.email.value && (
              <CircleCheckIcon className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4" style={{ color: '#22c55e' }} />
            )}
          </div>
          {form.email.touched && form.email.error && (
            <p className="mt-1.5 text-xs font-medium" style={{ color: '#f87171' }}>{form.email.error}</p>
          )}
        </div>

        {/* Company */}
        <div>
          <label className="block text-xs font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(180,200,255,0.5)' }}>
            Company
          </label>
          <input
            type="text"
            placeholder="Your brand or company"
            value={form.company.value}
            onChange={e => handleChange('company', e.target.value)}
            onBlur={() => handleBlur('company')}
            onFocus={() => setFocusedField('company')}
            style={{ ...inputBase, ...getFieldStyle('company') }}
          />
        </div>

        {/* Budget */}
        <div>
          <label className="block text-xs font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(180,200,255,0.5)' }}>
            Campaign Budget
          </label>
          <select
            value={form.budget.value}
            onChange={e => handleChange('budget', e.target.value)}
            onBlur={() => handleBlur('budget')}
            onFocus={() => setFocusedField('budget')}
            style={{ ...inputBase, ...getFieldStyle('budget'), appearance: 'none', cursor: 'pointer' }}
          >
            <option value="" style={{ background: '#0d1117', color: '#e2e8f0' }}>Select a range</option>
            {budgetOptions.map(opt => (
              <option key={opt} value={opt} style={{ background: '#0d1117', color: '#e2e8f0' }}>{opt}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Message */}
      <div className="mb-7">
        <label className="block text-xs font-bold uppercase tracking-widest mb-2" style={{ color: 'rgba(0,212,255,0.7)' }}>
          Tell Us About Your Campaign <span style={{ color: '#f87171' }}>*</span>
        </label>
        <div className="relative">
          <textarea
            rows={5}
            placeholder="Describe your brand, target audience, campaign goals, and preferred Bengaluru zones..."
            value={form.message.value}
            onChange={e => handleChange('message', e.target.value)}
            onBlur={() => handleBlur('message')}
            onFocus={() => setFocusedField('message')}
            style={{ ...inputBase, ...getFieldStyle('message'), resize: 'none' }}
          />
          <div className="absolute bottom-3 right-3 text-xs font-medium" style={{ color: form.message.value.length > 0 ? 'rgba(0,212,255,0.5)' : 'rgba(180,200,255,0.3)' }}>
            {form.message.value.length} chars
          </div>
        </div>
        {form.message.touched && form.message.error && (
          <p className="mt-1.5 text-xs font-medium" style={{ color: '#f87171' }}>{form.message.error}</p>
        )}
      </div>

      {/* Submit */}
      <div className="flex justify-center">
        <MagneticButton strength={0.35} onClick={() => {}}>
          <button
            type="submit"
            disabled={submitting}
            className="relative inline-flex items-center gap-3 rounded-full font-black text-lg px-10 py-4 overflow-hidden group"
            style={{
              background: submitting ? 'rgba(0,212,255,0.15)' : 'linear-gradient(135deg, #00d4ff 0%, #7c3aed 60%, #f59e0b 100%)',
              backgroundSize: '200% 200%',
              animation: submitting ? 'none' : 'gradientShift 3s ease infinite',
              color: submitting ? 'rgba(0,212,255,0.6)' : '#fff',
              border: submitting ? '1px solid rgba(0,212,255,0.3)' : 'none',
              boxShadow: submitting ? 'none' : '0 0 40px rgba(0,212,255,0.35), 0 0 80px rgba(124,58,237,0.2)',
              transition: 'all 0.4s cubic-bezier(0.23,1,0.32,1)',
              cursor: submitting ? 'not-allowed' : 'none',
              fontFamily: 'DM Sans, sans-serif',
              minWidth: '220px',
              justifyContent: 'center',
            }}
          >
            <span
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-full"
              style={{ background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.15) 0%, transparent 70%)' }}
            />
            {submitting ? (
              <>
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                <span>Sending…</span>
              </>
            ) : (
              <>
                <SendIcon className="h-5 w-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
                <span>Launch My Campaign</span>
              </>
            )}
          </button>
        </MagneticButton>
      </div>
    </form>
  );
}

// ─── Main Page ────────────────────────────────────────────────────────────────
export default function HomePage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [statsInView, setStatsInView] = useState(false);
  const statsRef = useRef<HTMLDivElement>(null);
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setStatsInView(true); },
      { threshold: 0.2 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);

  const navLinks = [
    { label: 'Home', href: '#home' },
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Why It Works', href: '#why-it-works' },
    { label: 'Solutions', href: '#solutions' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'About', href: '#about' },
    { label: 'FAQs', href: '#faqs' },
  ];

  const particles = [
    { x: 10, y: 20, size: 4, color: '#00d4ff', duration: 8, delay: 0 },
    { x: 85, y: 15, size: 6, color: '#7c3aed', duration: 10, delay: 1 },
    { x: 25, y: 70, size: 3, color: '#00d4ff', duration: 7, delay: 2 },
    { x: 70, y: 60, size: 5, color: '#f59e0b', duration: 9, delay: 0.5 },
    { x: 50, y: 85, size: 4, color: '#7c3aed', duration: 11, delay: 1.5 },
    { x: 90, y: 75, size: 3, color: '#00d4ff', duration: 8, delay: 3 },
    { x: 15, y: 45, size: 5, color: '#f59e0b', duration: 12, delay: 2.5 },
    { x: 60, y: 30, size: 3, color: '#7c3aed', duration: 9, delay: 4 },
  ];

  return (
    <div className="min-h-screen font-sans" style={{ background: '#050810', color: '#e2e8f0', cursor: 'none' }}>
      <CustomCursor />
      <NoiseOverlay />

      {/* ─── NAVBAR ─────────────────────────────────────────────────────── */}
      <header
        className="sticky top-0 z-50 transition-all duration-500"
        style={{
          background: scrolled ? 'rgba(5,8,16,0.85)' : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(0,212,255,0.1)' : '1px solid transparent',
          boxShadow: scrolled ? '0 0 40px rgba(0,212,255,0.05)' : 'none',
        }}
      >
        <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 lg:px-8">
          <a href="#home" className="flex items-center gap-2.5 group">
            <div
              className="p-2 rounded-xl transition-all duration-300 group-hover:scale-110"
              style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)', boxShadow: '0 0 20px rgba(0,212,255,0.4)' }}
            >
              <DropletIcon className="h-6 w-6 text-white" />
            </div>
            <span className="font-black text-2xl" style={{ fontFamily: 'DM Sans, sans-serif', background: 'linear-gradient(135deg, #00d4ff, #a78bfa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Aqvertise 360°
            </span>
          </a>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="relative text-sm font-semibold transition-colors duration-200 group"
                style={{ color: 'rgba(180,200,255,0.8)' }}
              >
                {link.label}
                <span
                  className="absolute -bottom-1 left-0 h-px transition-all duration-300 group-hover:w-full"
                  style={{ width: 0, background: 'linear-gradient(90deg, #00d4ff, #7c3aed)' }}
                />
              </a>
            ))}
          </div>

          <div className="hidden lg:flex">
            <MagneticButton href="#contact">
              <button
                className="inline-flex items-center gap-2 rounded-full font-bold px-5 py-2.5 text-sm transition-all duration-300 hover:scale-105"
                style={{
                  background: 'linear-gradient(135deg, #00d4ff, #7c3aed)',
                  color: '#fff',
                  boxShadow: '0 0 30px rgba(0,212,255,0.3)',
                  fontFamily: 'DM Sans, sans-serif',
                }}
              >
                Get Started
                <ArrowRightIcon className="h-4 w-4" />
              </button>
            </MagneticButton>
          </div>

          <button
            className="lg:hidden p-2.5 rounded-xl transition-colors"
            style={{ color: '#00d4ff', border: '1px solid rgba(0,212,255,0.2)' }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <XIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
          </button>
        </nav>

        {mobileMenuOpen && (
          <div
            className="lg:hidden px-4 py-6 space-y-4"
            style={{ background: 'rgba(5,8,16,0.97)', borderTop: '1px solid rgba(0,212,255,0.1)' }}
          >
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="block text-sm font-semibold py-2 transition-colors"
                style={{ color: 'rgba(180,200,255,0.8)' }}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setMobileMenuOpen(false)}>
              <button
                className="w-full mt-2 rounded-full font-bold px-6 py-3 text-sm"
                style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)', color: '#fff' }}
              >
                Get Started
              </button>
            </a>
          </div>
        )}
      </header>

      <main>
        {/* ─── HERO ───────────────────────────────────────────────────────── */}
        <section id="home" ref={heroRef} className="relative overflow-hidden" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
          {/* Parallax background layers */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ transform: `translateY(${scrollY * 0.4}px)` }}
          >
            <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 0%, rgba(0,212,255,0.12) 0%, transparent 60%)' }} />
            <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 60% 50% at 80% 80%, rgba(124,58,237,0.1) 0%, transparent 60%)' }} />
            <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse 40% 40% at 20% 60%, rgba(245,158,11,0.06) 0%, transparent 60%)' }} />
          </div>

          {/* Grid */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage: 'linear-gradient(rgba(0,212,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.04) 1px, transparent 1px)',
              backgroundSize: '60px 60px',
              transform: `translateY(${scrollY * 0.15}px)`,
            }}
          />

          {/* Floating particles */}
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            {particles.map((p, i) => <Particle key={i} {...p} />)}
          </div>

          {/* Glowing orbs */}
          <div className="absolute pointer-events-none" style={{ top: '10%', left: '5%', width: 400, height: 400, background: 'radial-gradient(circle, rgba(0,212,255,0.08) 0%, transparent 70%)', borderRadius: '50%', filter: 'blur(40px)', animation: 'orbFloat 12s ease-in-out infinite' }} />
          <div className="absolute pointer-events-none" style={{ bottom: '10%', right: '5%', width: 500, height: 500, background: 'radial-gradient(circle, rgba(124,58,237,0.08) 0%, transparent 70%)', borderRadius: '50%', filter: 'blur(40px)', animation: 'orbFloat 15s ease-in-out 3s infinite reverse' }} />

          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-32 w-full">
            <div className="mx-auto max-w-5xl text-center">
              {/* Badge */}
              <Reveal delay={0}>
                <div
                  className="mb-8 inline-flex items-center gap-2 rounded-full px-5 py-2.5"
                  style={{ background: 'rgba(0,212,255,0.08)', border: '1px solid rgba(0,212,255,0.25)', backdropFilter: 'blur(10px)' }}
                >
                  <SparklesIcon className="h-4 w-4" style={{ color: '#00d4ff' } as React.CSSProperties} />
                  <span className="text-sm font-semibold tracking-wide" style={{ color: '#00d4ff' }}>
                    Bengaluru&apos;s First Hydration-Based OOH Advertising Network
                  </span>
                </div>
              </Reveal>

              {/* Headline */}
              <div className="mb-6 overflow-hidden">
                <AnimatedHeadline
                  text="Out-of-Home Advertising"
                  className="text-5xl sm:text-6xl lg:text-8xl font-black leading-none tracking-tight text-white"
                  delay={100}
                />
                <AnimatedHeadline
                  text="That People Actually"
                  className="text-5xl sm:text-6xl lg:text-8xl font-black leading-none tracking-tight text-white mt-2"
                  delay={200}
                />
                <div className="overflow-hidden mt-2">
                  <span
                    className="block text-5xl sm:text-6xl lg:text-8xl font-black leading-none tracking-tight"
                    style={{
                      fontFamily: 'DM Sans, sans-serif',
                      background: 'linear-gradient(135deg, #00d4ff 0%, #7c3aed 50%, #f59e0b 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundSize: '200% 200%',
                      animation: 'gradientShift 4s ease infinite',
                    }}
                  >
                    Remember.
                  </span>
                </div>
              </div>

              {/* Subtext */}
              <Reveal delay={400}>
                <p className="mx-auto mt-8 max-w-3xl text-xl sm:text-2xl leading-relaxed" style={{ color: 'rgba(180,200,255,0.7)' }}>
                  Bengaluru is India&apos;s attention capital—and also one of its most ad-cluttered cities.{' '}
                  <span className="font-bold" style={{ color: '#00d4ff' }}>Aqvertise360 helps brands cut through the noise</span>{' '}
                  with a new kind of OOH advertising that isn&apos;t just seen, but handled, consumed, and remembered.
                </p>
              </Reveal>

              {/* CTAs */}
              <Reveal delay={550}>
                <div className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
                  <MagneticButton href="#contact">
                    <button
                      className="inline-flex items-center gap-2 rounded-full font-bold px-8 py-4 text-lg transition-all duration-300 hover:scale-105 group"
                      style={{
                        background: 'linear-gradient(135deg, #00d4ff, #7c3aed)',
                        color: '#fff',
                        boxShadow: '0 0 40px rgba(0,212,255,0.4), 0 0 80px rgba(124,58,237,0.2)',
                        fontFamily: 'DM Sans, sans-serif',
                      }}
                    >
                      Book a Bengaluru Pilot Campaign
                      <ArrowRightIcon className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
                    </button>
                  </MagneticButton>
                  <MagneticButton href="#contact">
                    <button
                      className="inline-flex items-center gap-2 rounded-full font-bold px-8 py-4 text-lg transition-all duration-300 hover:scale-105"
                      style={{
                        background: 'transparent',
                        color: 'rgba(180,200,255,0.9)',
                        border: '1px solid rgba(0,212,255,0.3)',
                        backdropFilter: 'blur(10px)',
                      }}
                    >
                      Talk to Our OOH Strategy Team
                    </button>
                  </MagneticButton>
                </div>
              </Reveal>

              {/* Stats */}
              <div className="mt-24" ref={statsRef}>
                <Reveal delay={0}>
                  <p className="text-xs font-black uppercase tracking-widest mb-8" style={{ color: '#00d4ff', letterSpacing: '0.3em' }}>
                    Proven Results in Real-World Campaigns
                  </p>
                </Reveal>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
                  <StatCard value="95%" label="Brand Recall Rate" numericValue={95} suffix="%" inView={statsInView} delay={0} />
                  <StatCard value="2×" label="Average Brand Lift" numericValue={2} suffix="×" inView={statsInView} delay={150} />
                  <StatCard value="50,000+" label="Daily High-Attention Impressions" numericValue={50000} suffix="+" inView={statsInView} delay={300} />
                  <StatCard value="95%" label="Engagement per Pack" numericValue={95} suffix="%" inView={statsInView} delay={450} />
                </div>
                <Reveal delay={600}>
                  <p className="mt-8 text-lg italic" style={{ color: 'rgba(180,200,255,0.6)' }}>
                    Every campaign is tracked, optimized, and aligned to real brand outcomes.
                  </p>
                </Reveal>
              </div>
            </div>
          </div>

          {/* Scroll indicator */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" style={{ animation: 'bounce 2s ease-in-out infinite' }}>
            <span className="text-xs font-semibold tracking-widest uppercase" style={{ color: 'rgba(0,212,255,0.5)' }}>Scroll</span>
            <div className="w-px h-12" style={{ background: 'linear-gradient(to bottom, rgba(0,212,255,0.5), transparent)' }} />
          </div>
        </section>

        {/* ─── MARQUEE STRIP ──────────────────────────────────────────────── */}
        <div className="overflow-hidden py-5" style={{ background: 'rgba(0,212,255,0.05)', borderTop: '1px solid rgba(0,212,255,0.1)', borderBottom: '1px solid rgba(0,212,255,0.1)' }}>
          <div className="marquee-track whitespace-nowrap">
            {[...Array(3)].map((_, i) => (
              <span key={i} className="inline-flex items-center gap-8 mx-8 text-sm font-bold uppercase tracking-widest" style={{ color: 'rgba(0,212,255,0.5)' }}>
                <span>Brand Recall</span><span style={{ color: '#7c3aed' }}>✦</span>
                <span>OOH Advertising</span><span style={{ color: '#7c3aed' }}>✦</span>
                <span>Hydration Media</span><span style={{ color: '#7c3aed' }}>✦</span>
                <span>Bengaluru Network</span><span style={{ color: '#7c3aed' }}>✦</span>
                <span>Zero Skip</span><span style={{ color: '#7c3aed' }}>✦</span>
                <span>Utility Advertising</span><span style={{ color: '#7c3aed' }}>✦</span>
                <span>CPRM Metric</span><span style={{ color: '#7c3aed' }}>✦</span>
              </span>
            ))}
          </div>
        </div>

        {/* ─── CHALLENGE + SOLUTION ──────────────────────────────────────── */}
        <section id="how-it-works" className="py-24 md:py-32 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 60% 50% at 0% 50%, rgba(0,212,255,0.04) 0%, transparent 60%)' }} />
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
              {/* Challenge */}
              <div>
                <Reveal delay={0}>
                  <span
                    className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6"
                    style={{ background: 'rgba(239,68,68,0.1)', color: '#f87171', border: '1px solid rgba(239,68,68,0.2)' }}
                  >
                    The Challenge
                  </span>
                  <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl text-white mb-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                    Why OOH Advertising in Bengaluru Needs a Rethink
                  </h2>
                  <p className="text-lg leading-relaxed mb-8" style={{ color: 'rgba(180,200,255,0.7)' }}>
                    Traditional OOH advertising in Bengaluru faces real challenges:
                  </p>
                </Reveal>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    'Oversaturated billboards and hoardings',
                    'Short attention spans and visual fatigue',
                    'Passive exposure with minimal engagement',
                    'High spend, low recall',
                  ].map((item, i) => (
                    <Reveal key={item} delay={i * 100} direction="left">
                      <div
                        className="group relative overflow-hidden rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1"
                        style={{
                          background: 'rgba(255,255,255,0.03)',
                          border: '1px solid rgba(255,255,255,0.08)',
                        }}
                      >
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ background: 'rgba(255,255,255,0.03)' }} />
                        <CircleXIcon className="h-8 w-8 mb-3 group-hover:scale-110 transition-transform" style={{ color: '#00d4ff' }} />
                        <p className="text-sm font-semibold text-white">{item}</p>
                      </div>
                    </Reveal>
                  ))}
                </div>

                <Reveal delay={400}>
                  <div className="mt-8 p-6 rounded-2xl" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <p className="text-lg font-semibold leading-relaxed" style={{ color: 'rgba(180,200,255,0.8)' }}>
                      In a city driven by startups, tech professionals, and decision-makers,{' '}
                      <span style={{ color: '#00d4ff' }}>visibility alone is no longer enough.</span>
                    </p>
                    <p className="mt-3 text-xl font-black text-white">
                      Brands need{' '}
                      <span style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                        attention with intent.
                      </span>
                    </p>
                  </div>
                </Reveal>
              </div>

              {/* Solution */}
              <div>
                <Reveal delay={100}>
                  <span
                    className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6"
                    style={{ background: 'rgba(0,212,255,0.1)', color: '#00d4ff', border: '1px solid rgba(0,212,255,0.2)' }}
                  >
                    The Solution
                  </span>
                  <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl text-white mb-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                    A Smarter OOH Format for Bengaluru
                  </h2>
                  <p className="text-lg font-bold mb-2" style={{ color: '#00d4ff' }}>Utility-Driven. Habit-Based. High Recall.</p>
                  <p className="text-lg leading-relaxed mb-8" style={{ color: 'rgba(180,200,255,0.7)' }}>
                    Aqvertise360 introduces Bengaluru&apos;s first hydration-based OOH advertising format—where branded water packs become a daily point of interaction between your brand and your audience.
                  </p>
                </Reveal>

                <div className="space-y-4">
                  {[
                    { icon: <DropletIcon className="h-6 w-6 text-white" />, color: '#00d4ff', title: 'Picked up willingly', desc: 'Water is the only medium people willingly engage with—multiple times a day.' },
                    { icon: <ClockIcon className="h-6 w-6 text-white" />, color: '#7c3aed', title: 'Consumed multiple times a day', desc: 'Hydration is repetitive, creating natural frequency and long-term brand recall.' },
                    { icon: <ZapIcon className="h-6 w-6 text-white" />, color: '#f59e0b', title: 'Associated with utility and care', desc: 'Creates repeated exposure, stronger memory, and higher brand recall than traditional OOH.' },
                  ].map((item, i) => (
                    <Reveal key={item.title} delay={i * 120} direction="right">
                      <div
                        className="group relative overflow-hidden rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1"
                        style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid rgba(${item.color === '#00d4ff' ? '0,212,255' : item.color === '#7c3aed' ? '124,58,237' : '245,158,11'},0.2)` }}
                      >
                        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `radial-gradient(circle at 0% 50%, ${item.color}10 0%, transparent 60%)` }} />
                        <div className="flex items-start gap-4 relative">
                          <div className="rounded-xl p-3 flex-shrink-0 group-hover:scale-110 transition-transform" style={{ background: `${item.color}15`, color: item.color, boxShadow: `0 0 20px ${item.color}20` }}>
                            {item.icon}
                          </div>
                          <div>
                            <h3 className="text-lg font-bold text-white mb-1">{item.title}</h3>
                            <p className="text-sm leading-relaxed" style={{ color: 'rgba(180,200,255,0.7)' }}>{item.desc}</p>
                          </div>
                        </div>
                      </div>
                    </Reveal>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ─── NETWORK ────────────────────────────────────────────────────── */}
        <section id="solutions" className="py-24 md:py-32 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 50%, rgba(124,58,237,0.05) 0%, transparent 70%)' }} />
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <Reveal>
                <span className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6" style={{ background: 'rgba(124,58,237,0.1)', color: '#a78bfa', border: '1px solid rgba(124,58,237,0.2)' }}>
                  Bengaluru OOH Network
                </span>
                <h2 className="text-3xl font-extrabold tracking-tight sm:text-5xl text-white mb-6" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  Where Your Brand Appears
                </h2>
                <p className="text-xl max-w-3xl mx-auto" style={{ color: 'rgba(180,200,255,0.7)' }}>
                  Strategically distributed across high-dwell, premium locations in Bengaluru.
                </p>
              </Reveal>
            </div>

            {/* Bento grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
              {[
                { icon: <Building2Icon className="h-8 w-8" />, color: '#00d4ff', title: 'Tech Parks & Corporate Campuses', desc: 'Whitefield, ORR, Electronic City, North Bengaluru', span: 'lg:col-span-2' },
                { icon: <UsersIcon className="h-8 w-8" />, color: '#7c3aed', title: 'Events & Conferences', desc: 'Startup events, business summits, trade shows', span: '' },
                { icon: <TargetIcon className="h-8 w-8" />, color: '#f59e0b', title: 'Institutions & Universities', desc: 'High-density youth and professional environments', span: '' },
                { icon: <MapPinIcon className="h-8 w-8" />, color: '#00d4ff', title: 'Transit & High-Dwell Zones', desc: 'Malls, hubs, and controlled public spaces', span: 'lg:col-span-2' },
              ].map((item, i) => (
                <Reveal key={item.title} delay={i * 100} className={item.span}>
                  <div
                    className="group relative overflow-hidden rounded-3xl p-8 h-full transition-all duration-500 hover:-translate-y-2"
                    style={{
                      background: 'rgba(255,255,255,0.03)',
                      border: `1px solid rgba(${item.color === '#00d4ff' ? '0,212,255' : item.color === '#7c3aed' ? '124,58,237' : '245,158,11'},0.15)`,
                    }}
                  >
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `radial-gradient(circle at 30% 30%, ${item.color}08 0%, transparent 60%)` }} />
                    <div className="absolute top-0 left-0 w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(0,212,255,0.5), transparent)' }} />
                    <div className="relative">
                      <div className="mb-5 inline-flex rounded-2xl p-4 group-hover:scale-110 transition-transform" style={{ background: `${item.color}15`, color: item.color, boxShadow: `0 0 20px ${item.color}20` }}>
                        {item.icon}
                      </div>
                      <h3 className="font-bold text-white text-lg mb-2">{item.title}</h3>
                      <p className="text-sm" style={{ color: 'rgba(180,200,255,0.6)' }}>{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={400}>
              <p className="mt-12 text-center text-lg max-w-3xl mx-auto font-medium" style={{ color: 'rgba(180,200,255,0.7)' }}>
                Each location is selected for{' '}
                <span style={{ color: '#00d4ff', fontWeight: 700 }}>context, dwell time, and audience quality</span>
                —not just footfall.
              </p>
            </Reveal>
          </div>
        </section>

        {/* ─── WHO USES ──────────────────────────────────────────────────── */}
        <section id="why-it-works" className="py-24 md:py-32 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 60% 50% at 100% 50%, rgba(0,212,255,0.04) 0%, transparent 60%)' }} />
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <Reveal>
                <span className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6" style={{ background: 'rgba(0,212,255,0.1)', color: '#00d4ff', border: '1px solid rgba(0,212,255,0.2)' }}>
                  Who Uses Aqvertise360
                </span>
                <h2 className="text-3xl font-extrabold tracking-tight sm:text-5xl text-white mb-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  Built for Brands That Value Recall Over Reach
                </h2>
              </Reveal>
            </div>

            <div className="max-w-4xl mx-auto">
              <Reveal>
                <div
                  className="group relative overflow-hidden rounded-3xl p-10 transition-all duration-500"
                  style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(0,212,255,0.15)' }}
                >
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700" style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(0,212,255,0.06) 0%, transparent 60%)' }} />
                  <div className="absolute top-0 left-0 w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(0,212,255,0.5), transparent)' }} />
                  <div className="relative">
                    <div className="flex items-center gap-4 mb-8">
                      <div className="p-4 rounded-2xl" style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)', boxShadow: '0 0 30px rgba(0,212,255,0.3)' }}>
                        <TargetIcon className="h-8 w-8 text-white" />
                      </div>
                      <h3 className="text-2xl font-extrabold text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>Ideal For:</h3>
                    </div>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {[
                        'Fintech & Edtech startups',
                        'Real estate developers',
                        'Consumer brands launching in Bengaluru',
                        'Employers focused on brand & talent visibility',
                        'Companies seeking premium brand dominance',
                      ].map((item, i) => (
                        <li
                          key={item}
                          className="flex items-start gap-3 group/item"
                          style={{
                            opacity: 1,
                            animation: `fadeSlideIn 0.5s ease ${i * 100}ms both`,
                          }}
                        >
                          <CircleCheckIcon className="h-6 w-6 flex-shrink-0 mt-0.5 group-hover/item:scale-110 transition-transform" style={{ color: '#00d4ff' }} />
                          <span className="text-lg font-medium" style={{ color: 'rgba(180,200,255,0.85)' }}>{item}</span>
                        </li>
                      ))}
                    </ul>
                    <p className="mt-8 text-lg text-center font-semibold italic" style={{ color: 'rgba(180,200,255,0.7)' }}>
                      If your audience is{' '}
                      <span style={{ color: '#00d4ff' }}>educated, urban, and hard to impress</span>
                      —this format works.
                    </p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* ─── WHY WE OUTPERFORM ─────────────────────────────────────────── */}
        <section id="pricing" className="py-24 md:py-32 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 100%, rgba(245,158,11,0.04) 0%, transparent 60%)' }} />
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <Reveal>
                <span className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6" style={{ background: 'rgba(245,158,11,0.1)', color: '#f59e0b', border: '1px solid rgba(245,158,11,0.2)' }}>
                  Why We Outperform
                </span>
                <h2 className="text-3xl font-extrabold tracking-tight sm:text-5xl text-white mb-4" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  Built on Psychology. Powered by Utility.
                </h2>
              </Reveal>
            </div>

            <div className="max-w-4xl mx-auto space-y-5">
              {[
                { icon: <DropletIcon className="h-8 w-8 text-white" />, color: '#00d4ff', title: 'Attention Through Utility', desc: 'Water is the only medium people willingly engage with—multiple times a day.' },
                { icon: <ClockIcon className="h-8 w-8 text-white" />, color: '#7c3aed', title: 'Habit-Driven Frequency', desc: 'Hydration is repetitive, reinforcing brand memory naturally.' },
                { icon: <ZapIcon className="h-8 w-8 text-white" />, color: '#f59e0b', title: 'Zero Skip Behaviour', desc: 'Screens can be ignored. Thirst cannot.' },
              ].map((item, i) => (
                <Reveal key={item.title} delay={i * 150}>
                  <div
                    className="group relative overflow-hidden rounded-2xl p-8 transition-all duration-500 hover:-translate-y-1"
                    style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid rgba(${item.color === '#00d4ff' ? '0,212,255' : item.color === '#7c3aed' ? '124,58,237' : '245,158,11'},0.15)` }}
                  >
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `radial-gradient(circle at 0% 50%, ${item.color}08 0%, transparent 60%)` }} />
                    <div className="absolute top-0 left-0 h-full w-1 rounded-full" style={{ background: item.color, boxShadow: `0 0 10px ${item.color}` }} />
                    <div className="flex items-start gap-6 relative pl-4">
                      <div className="rounded-xl p-4 flex-shrink-0 group-hover:scale-110 transition-transform" style={{ background: `${item.color}15`, color: item.color, boxShadow: `0 0 20px ${item.color}20` }}>
                        {item.icon}
                      </div>
                      <div>
                        <h3 className="text-2xl font-extrabold text-white mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>{item.title}</h3>
                        <p className="text-base leading-relaxed" style={{ color: 'rgba(180,200,255,0.7)' }}>{item.desc}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={450}>
              <p className="mt-12 text-center text-xl max-w-3xl mx-auto font-bold" style={{ color: 'rgba(180,200,255,0.8)' }}>
                This is OOH advertising designed for{' '}
                <span style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  memory, not just impressions.
                </span>
              </p>
            </Reveal>
          </div>
        </section>

        {/* ─── CPRM ──────────────────────────────────────────────────────── */}
        <section id="about" className="py-24 md:py-32 relative overflow-hidden">
          {/* Animated background */}
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(0,212,255,0.05) 0%, rgba(124,58,237,0.08) 50%, rgba(245,158,11,0.04) 100%)' }} />
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, rgba(0,212,255,0.06) 1px, transparent 1px)', backgroundSize: '50px 50px' }} />
          </div>
          <div className="absolute pointer-events-none" style={{ top: '-20%', left: '-10%', width: 600, height: 600, background: 'radial-gradient(circle, rgba(0,212,255,0.06) 0%, transparent 70%)', borderRadius: '50%', filter: 'blur(60px)', animation: 'orbFloat 18s ease-in-out infinite' }} />
          <div className="absolute pointer-events-none" style={{ bottom: '-20%', right: '-10%', width: 600, height: 600, background: 'radial-gradient(circle, rgba(124,58,237,0.06) 0%, transparent 70%)', borderRadius: '50%', filter: 'blur(60px)', animation: 'orbFloat 20s ease-in-out 5s infinite reverse' }} />

          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-5xl text-center">
              <Reveal>
                <span className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6" style={{ background: 'linear-gradient(135deg, rgba(0,212,255,0.15), rgba(124,58,237,0.15))', color: '#a78bfa', border: '1px solid rgba(124,58,237,0.3)' }}>
                  A New Way to Measure OOH Performance
                </span>
                <h2 className="text-3xl font-extrabold tracking-tight sm:text-5xl text-white mb-6" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  Introducing CPRM
                </h2>
                <p className="text-2xl sm:text-3xl font-bold mb-12" style={{ color: '#00d4ff' }}>
                  Cost Per{' '}
                  <span className="text-white underline decoration-cyan-400 decoration-4">Remembered</span>{' '}
                  Impression
                </p>
              </Reveal>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch mb-12">
                <Reveal delay={100} direction="left">
                  <div
                    className="text-left p-8 rounded-3xl h-full"
                    style={{ background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.15)' }}
                  >
                    <div className="flex items-center gap-3 mb-6">
                      <div className="p-3 rounded-xl" style={{ background: 'rgba(239,68,68,0.2)' }}>
                        <CircleXIcon className="h-6 w-6" style={{ color: '#f87171' }} />
                      </div>
                      <h3 className="text-xl font-extrabold" style={{ color: '#f87171' }}>Traditional OOH uses CPM</h3>
                    </div>
                    <p className="text-lg leading-relaxed" style={{ color: 'rgba(180,200,255,0.7)' }}>
                      which measures <span className="text-white font-semibold">exposure</span>—not impact.
                    </p>
                  </div>
                </Reveal>

                <Reveal delay={200} direction="right">
                  <div
                    className="text-left p-8 rounded-3xl h-full"
                    style={{ background: 'linear-gradient(135deg, rgba(0,212,255,0.08), rgba(124,58,237,0.08))', border: '1px solid rgba(0,212,255,0.25)', boxShadow: '0 0 40px rgba(0,212,255,0.08)' }}
                  >
                    <div className="flex items-center gap-3 mb-6">
                      <div className="p-3 rounded-xl" style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)' }}>
                        <ZapIcon className="h-6 w-6 text-white" />
                      </div>
                      <h3 className="text-xl font-extrabold text-white">Aqvertise360 measures</h3>
                    </div>
                    <p className="text-lg text-white leading-relaxed">
                      <span style={{ color: '#00d4ff', fontWeight: 700 }}>remembered impressions</span>, because memory drives:
                    </p>
                    <ul className="mt-4 space-y-2">
                      {['Brand recall', 'Consideration', 'Action'].map((item) => (
                        <li key={item} className="flex items-center gap-2 text-white">
                          <CircleCheckIcon className="h-5 w-5" style={{ color: '#00d4ff' }} />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Reveal>
              </div>

              <Reveal delay={300}>
                <div
                  className="p-10 rounded-3xl relative overflow-hidden"
                  style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(124,58,237,0.2)' }}
                >
                  <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at 50% 100%, rgba(124,58,237,0.08) 0%, transparent 60%)' }} />
                  <p className="relative text-3xl sm:text-4xl font-bold text-white italic leading-relaxed">
                    &ldquo;Brands don&apos;t compete for space in Bengaluru.<br />
                    <span style={{ background: 'linear-gradient(135deg, #00d4ff, #a78bfa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                      They compete for memory.&rdquo;
                    </span>
                  </p>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* ─── WHY BRANDS CHOOSE US ──────────────────────────────────────── */}
        <section id="faqs" className="py-24 md:py-32 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 50%, rgba(0,212,255,0.04) 0%, transparent 60%)' }} />
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
              <Reveal>
                <span className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6" style={{ background: 'rgba(0,212,255,0.1)', color: '#00d4ff', border: '1px solid rgba(0,212,255,0.2)' }}>
                  Why Brands Choose Us
                </span>
                <h2 className="text-3xl font-extrabold tracking-tight sm:text-5xl text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  Why Brands Choose Aqvertise360
                </h2>
              </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto mb-12">
              {[
                { icon: <SparklesIcon className="h-10 w-10" />, label: 'Premium, clutter-free OOH format', color: '#00d4ff' },
                { icon: <DropletIcon className="h-10 w-10" />, label: 'Strong association with wellness and utility', color: '#7c3aed' },
                { icon: <UsersIcon className="h-10 w-10" />, label: 'High-quality professional audience', color: '#f59e0b' },
                { icon: <ChartColumnIcon className="h-10 w-10" />, label: 'Measurable brand recall, not vanity metrics', color: '#00d4ff' },
                { icon: <MapPinIcon className="h-10 w-10" />, label: 'Scalable across multiple Bengaluru zones', color: '#7c3aed' },
                { icon: <TrendingUpIcon className="h-10 w-10" />, label: 'Proven campaign performance', color: '#f59e0b' },
              ].map((item, i) => (
                <Reveal key={item.label} delay={i * 80}>
                  <div
                    className="group relative overflow-hidden p-6 rounded-2xl transition-all duration-300 hover:-translate-y-2"
                    style={{
                      background: 'rgba(255,255,255,0.03)',
                      border: `1px solid rgba(${item.color === '#00d4ff' ? '0,212,255' : item.color === '#7c3aed' ? '124,58,237' : '245,158,11'},0.15)`,
                    }}
                  >
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: `radial-gradient(circle at 50% 0%, ${item.color}08 0%, transparent 60%)` }} />
                    <div className="absolute top-0 left-0 w-full h-px" style={{ background: `linear-gradient(90deg, transparent, ${item.color}60, transparent)`, opacity: 0, transition: 'opacity 0.3s' }} />
                    <div className="mb-4 group-hover:scale-110 transition-transform" style={{ color: item.color }}>
                      {item.icon}
                    </div>
                    <p className="text-lg font-semibold text-white">{item.label}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={500}>
              <div className="text-center max-w-2xl mx-auto">
                <p className="text-2xl font-bold text-white mb-2">This isn&apos;t mass advertising.</p>
                <p className="text-2xl font-black" style={{ background: 'linear-gradient(135deg, #00d4ff, #a78bfa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                  It&apos;s intentional brand placement.
                </p>
              </div>
            </Reveal>
          </div>
        </section>

        {/* ─── CTA SECTION ───────────────────────────────────────────────── */}
        <section id="contact" className="py-24 md:py-32 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(0,212,255,0.06) 0%, rgba(124,58,237,0.08) 50%, rgba(245,158,11,0.04) 100%)' }} />
            <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.12) 0%, transparent 70%)', filter: 'blur(60px)', animation: 'orbFloat 10s ease-in-out infinite' }} />
            <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.12) 0%, transparent 70%)', filter: 'blur(60px)', animation: 'orbFloat 12s ease-in-out 2s infinite reverse' }} />
            <div className="absolute top-1/2 right-0 w-64 h-64 rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(245,158,11,0.08) 0%, transparent 70%)', filter: 'blur(40px)', animation: 'orbFloat 14s ease-in-out 4s infinite' }} />
            {/* Grid overlay */}
            <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(rgba(0,212,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,212,255,0.03) 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
          </div>

          <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start max-w-6xl mx-auto">

              {/* Left — Info panel */}
              <div>
                <Reveal delay={0}>
                  <span
                    className="inline-block rounded-full px-4 py-1.5 text-xs font-black uppercase tracking-widest mb-6"
                    style={{ background: 'rgba(0,212,255,0.1)', color: '#00d4ff', border: '1px solid rgba(0,212,255,0.25)' }}
                  >
                    Start a Campaign
                  </span>
                  <h2 className="text-4xl sm:text-5xl font-black text-white mb-6 leading-tight" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                    Put Your Brand in<br />
                    <span style={{ background: 'linear-gradient(135deg, #00d4ff 0%, #7c3aed 50%, #f59e0b 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundSize: '200% 200%', animation: 'gradientShift 4s ease infinite', display: 'inline-block' }}>
                      People&apos;s Hands
                    </span>
                  </h2>
                  <p className="text-lg leading-relaxed mb-10" style={{ color: 'rgba(180,200,255,0.7)' }}>
                    If you&apos;re looking for an OOH advertising solution in Bengaluru that delivers attention, recall, and credibility — Aqvertise360 is built for you.
                  </p>
                </Reveal>

                <div className="space-y-4">
                  {[
                    { icon: <MailIcon className="h-5 w-5" />, label: 'Email Us', value: 'info@aqvertise360.com', href: 'mailto:info@aqvertise360.com', color: '#00d4ff' },
                    { icon: <PhoneIcon className="h-5 w-5" />, label: 'Call Us', value: '+91 91871 25151', href: 'tel:+919187125151', color: '#7c3aed' },
                    { icon: <MapPinIcon className="h-5 w-5" />, label: 'Location', value: 'Bangalore, India', href: '#', color: '#f59e0b' },
                    { icon: <ClockIcon className="h-5 w-5" />, label: 'Response Time', value: 'Within 24 hours', href: '#', color: '#00d4ff' },
                  ].map((item, i) => (
                    <Reveal key={item.label} delay={i * 80} direction="left">
                      <a
                        href={item.href}
                        className="group flex items-center gap-4 p-4 rounded-2xl transition-all duration-300 hover:-translate-y-0.5"
                        style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}
                      >
                        <div
                          className="flex-shrink-0 p-2.5 rounded-xl group-hover:scale-110 transition-transform"
                          style={{ background: `${item.color}15`, color: item.color, boxShadow: `0 0 16px ${item.color}20` }}
                        >
                          {item.icon}
                        </div>
                        <div>
                          <p className="text-xs font-bold uppercase tracking-widest mb-0.5" style={{ color: 'rgba(180,200,255,0.4)' }}>{item.label}</p>
                          <p className="text-sm font-semibold text-white">{item.value}</p>
                        </div>
                        <ArrowRightIcon className="h-4 w-4 ml-auto opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-300" style={{ color: item.color }} />
                      </a>
                    </Reveal>
                  ))}
                </div>
              </div>

              {/* Right — Form */}
              <Reveal delay={150} direction="right">
                <div
                  className="relative overflow-hidden rounded-3xl p-8 sm:p-10"
                  style={{
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(0,212,255,0.15)',
                    backdropFilter: 'blur(24px)',
                    WebkitBackdropFilter: 'blur(24px)',
                    boxShadow: '0 0 60px rgba(0,212,255,0.06), inset 0 1px 0 rgba(255,255,255,0.06)',
                  }}
                >
                  {/* Top shimmer line */}
                  <div className="absolute top-0 left-0 w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(0,212,255,0.6), rgba(124,58,237,0.6), transparent)' }} />
                  {/* Corner glow */}
                  <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full pointer-events-none" style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.08) 0%, transparent 70%)', filter: 'blur(20px)' }} />

                  <div className="relative">
                    <div className="mb-8">
                      <h3 className="text-2xl font-black text-white mb-1" style={{ fontFamily: 'DM Sans, sans-serif' }}>Book a Pilot Campaign</h3>
                      <p className="text-sm" style={{ color: 'rgba(180,200,255,0.5)' }}>Fill in the details and we&apos;ll craft a custom OOH strategy for you.</p>
                    </div>
                    <ContactForm />
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </section>
      </main>

      {/* ─── FOOTER ─────────────────────────────────────────────────────── */}
      <footer className="relative overflow-hidden" style={{ background: 'rgba(255,255,255,0.02)', borderTop: '1px solid rgba(0,212,255,0.1)' }}>
        <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 80% 50% at 50% 100%, rgba(0,212,255,0.04) 0%, transparent 60%)' }} />

        <div className="relative mx-auto max-w-7xl px-6 py-16 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div className="lg:col-span-1">
              <a href="#home" className="flex items-center gap-2 mb-6 group">
                <div className="p-2 rounded-xl transition-transform duration-300 group-hover:scale-110" style={{ background: 'linear-gradient(135deg, #00d4ff, #7c3aed)' }}>
                  <DropletIcon className="h-6 w-6 text-white" />
                </div>
                <span className="font-black text-2xl text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>Aqvertise 360°</span>
              </a>
              <p className="text-sm leading-relaxed mb-6" style={{ color: 'rgba(180,200,255,0.6)' }}>
                Bengaluru&apos;s first hydration-based out-of-home advertising network, helping brands achieve real visibility and lasting brand recall.
              </p>
              <div className="flex gap-3">
                {[
                  { icon: <TwitterIcon className="h-5 w-5" />, label: 'Twitter' },
                  { icon: <LinkedInIcon className="h-5 w-5" />, label: 'LinkedIn' },
                  { icon: <InstagramIcon className="h-5 w-5" />, label: 'Instagram' },
                ].map((social) => (
                  <a
                    key={social.label}
                    href="#"
                    aria-label={social.label}
                    className="p-2 rounded-lg transition-all duration-300 hover:scale-110"
                    style={{ background: 'rgba(0,212,255,0.08)', color: '#00d4ff', border: '1px solid rgba(0,212,255,0.15)' }}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="font-bold text-white mb-4 text-base">Quick Links</h3>
              <ul className="space-y-3">
                {[
                  { label: 'Home', href: '#home' },
                  { label: 'How It Works', href: '#how-it-works' },
                  { label: 'Why It Works', href: '#why-it-works' },
                  { label: 'Solutions', href: '#solutions' },
                ].map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm flex items-center gap-2 group transition-colors" style={{ color: 'rgba(180,200,255,0.6)' }}>
                      <span className="w-0 h-px group-hover:w-4 transition-all duration-300" style={{ background: '#00d4ff' }} />
                      <span className="group-hover:text-cyan-400 transition-colors">{link.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-white mb-4 text-base">Company</h3>
              <ul className="space-y-3">
                {[
                  { label: 'Pricing', href: '#pricing' },
                  { label: 'About', href: '#about' },
                  { label: 'FAQs', href: '#faqs' },
                  { label: 'Contact', href: '#contact' },
                ].map((link) => (
                  <li key={link.label}>
                    <a href={link.href} className="text-sm flex items-center gap-2 group transition-colors" style={{ color: 'rgba(180,200,255,0.6)' }}>
                      <span className="w-0 h-px group-hover:w-4 transition-all duration-300" style={{ background: '#00d4ff' }} />
                      <span className="group-hover:text-cyan-400 transition-colors">{link.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-white mb-4 text-base">Get in Touch</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-sm" style={{ color: 'rgba(180,200,255,0.6)' }}>
                  <MailIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#00d4ff' }} />
                  <a href="mailto:info@aqvertise360.com" className="hover:text-cyan-400 transition-colors">info@aqvertise360.com</a>
                </li>
                <li className="flex items-start gap-3 text-sm" style={{ color: 'rgba(180,200,255,0.6)' }}>
                  <PhoneIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#00d4ff' }} />
                  <a href="tel:+919187125151" className="hover:text-cyan-400 transition-colors">+91 91871 25151</a>
                </li>
                <li className="flex items-start gap-3 text-sm" style={{ color: 'rgba(180,200,255,0.6)' }}>
                  <MapPinIcon className="h-5 w-5 flex-shrink-0 mt-0.5" style={{ color: '#00d4ff' }} />
                  <span>Bangalore, India</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8" style={{ borderTop: '1px solid rgba(0,212,255,0.08)' }}>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm" style={{ color: 'rgba(180,200,255,0.4)' }}>© 2026 Aqvertise 360°. All rights reserved.</p>
              <div className="flex gap-6 text-sm">
                <a href="#" className="hover:text-cyan-400 transition-colors" style={{ color: 'rgba(180,200,255,0.4)' }}>Privacy Policy</a>
                <a href="#" className="hover:text-cyan-400 transition-colors" style={{ color: 'rgba(180,200,255,0.4)' }}>Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
